/* Holiday Quick Ship landing page: variant picker state and countdowns. No tracking code here;
   add-to-cart posts to Shopify's native /cart/add so the store's native pixels see it. */
(function () {
  function updateCard(select) {
    var opt = select.options[select.selectedIndex];
    var form = select.closest('form');
    var btn = form.querySelector('[data-hqs-atc]');
    var low = form.querySelector('[data-hqs-low]');
    var available = opt && !opt.disabled && opt.dataset.available === 'true';
    btn.disabled = !available;
    btn.textContent = available ? btn.dataset.addLabel : btn.dataset.soldLabel;
    var qty = parseInt(opt && opt.dataset.qty, 10);
    var threshold = parseInt(form.dataset.threshold, 10) || 5;
    low.textContent = available && qty > 0 && qty <= threshold ? low.dataset.template.replace('[count]', qty) : '';
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-hqs-variant]')) updateCard(e.target);
  });
  document.querySelectorAll('[data-hqs-variant]').forEach(updateCard);

  function tick(el) {
    var end = Date.parse(el.dataset.end);
    if (isNaN(end)) return;
    var left = Math.max(0, end - Date.now());
    if (left === 0 && el.dataset.hideWhenDone === 'true') {
      var section = el.closest('.shopify-section');
      if (section && !window.Shopify.designMode) section.style.display = 'none';
      return;
    }
    var s = Math.floor(left / 1000);
    var parts = { d: Math.floor(s / 86400), h: Math.floor(s / 3600) % 24, m: Math.floor(s / 60) % 60, s: s % 60 };
    Object.keys(parts).forEach(function (k) {
      var n = el.querySelector('[data-unit="' + k + '"]');
      if (n) n.textContent = String(parts[k]).padStart(2, '0');
    });
    setTimeout(function () { tick(el); }, 1000);
  }
  window.Shopify = window.Shopify || {};
  document.querySelectorAll('[data-hqs-countdown]').forEach(tick);
})();
